(() => {

class ProductBuilder {

  constructor(builder) {

    this.builder = builder;

    this.cache();

    this.bindEvents();

    this.calculate();

  }

  cache() {

    this.includeMainProduct =
      this.builder.dataset.includeMainProduct === 'true';

    this.totalElement =
      this.builder.querySelector(
        '[data-builder-total]'
      );

    this.addButton =
      this.builder.querySelector(
        '[data-builder-add]'
      );

    this.items = [

      ...this.builder.querySelectorAll(
        '[data-builder-item]'
      )

    ];

    this.mainForm =
      document.querySelector(
        'form[action*="/cart/add"]'
      );

    this.variantInput =
      this.mainForm
        ? this.mainForm.querySelector(
            '[name="id"]'
          )
        : null;

    this.currentMainVariant = {

      id: this.variantInput
        ? Number(this.variantInput.value)
        : null,

      price: 0

    };

  }

  money(cents) {

    cents = Number(cents || 0);

    return '$' + (cents / 100).toFixed(2);

  }

  bindEvents() {

    this.bindQuantity();

    this.bindAccessoryVariants();

    this.bindMainVariant();

    this.bindAddToCart();

  }

    bindQuantity() {

    this.builder.addEventListener('click', (event) => {

      const plus = event.target.closest('[data-builder-plus]');
      const minus = event.target.closest('[data-builder-minus]');

      if (!plus && !minus) return;

      const qtyWrapper = event.target.closest(
        '.product-builder-item__qty'
      );

      if (!qtyWrapper) return;

      const input = qtyWrapper.querySelector(
        '[data-builder-qty]'
      );

      if (!input) return;

      let value = Number(input.value || 0);

      if (plus) {
        value++;
      }

      if (minus) {
        value = Math.max(0, value - 1);
      }

      input.value = value;

      this.calculate();

    });

    this.builder.addEventListener('input', (event) => {

      if (
        !event.target.matches(
          '[data-builder-qty]'
        )
      ) {
        return;
      }

      let qty = Number(event.target.value);

      if (isNaN(qty) || qty < 0) {
        qty = 0;
      }

      event.target.value = qty;

      this.calculate();

    });

  }

  bindAccessoryVariants() {

    this.builder.addEventListener('change', (event) => {

      if (
        !event.target.matches(
          '[data-builder-variant]'
        )
      ) {
        return;
      }

      const select = event.target;

      const item = select.closest(
        '[data-builder-item]'
      );

      if (!item) return;

      const option =
        select.options[
          select.selectedIndex
        ];

      item.dataset.variantId =
        option.value;

      item.dataset.price =
        option.dataset.price;

      const priceElement =
        item.querySelector(
          '[data-builder-price]'
        );

      if (priceElement) {

        priceElement.textContent =
          this.money(
            option.dataset.price
          );

      }

      this.calculate();

    });

  }

    bindMainVariant() {

    document.addEventListener(

      'custom:variant-change',

      (event) => {

        if (!event.detail) return;

        const variant = event.detail.variant;

        if (!variant) return;

        this.currentMainVariant = {

          id: Number(variant.id),

          price: Number(variant.price)

        };

        if (this.variantInput) {

          this.variantInput.value =
            variant.id;

        }

        this.calculate();

      }

    );

  }

  getAccessoryItems() {

    const items = [];

    this.items.forEach((item) => {

      const qty = Number(

        item.querySelector(
          '[data-builder-qty]'
        ).value || 0

      );

      if (qty <= 0) return;

      items.push({

        id: Number(
          item.dataset.variantId
        ),

        quantity: qty,

        price: Number(
          item.dataset.price
        )

      });

    });

    return items;

  }

  calculate() {

    let total = 0;

    if (this.includeMainProduct) {

      total +=
        this.currentMainVariant.price;

    }

    this.getAccessoryItems()
      .forEach((item) => {

        total +=
          item.price *
          item.quantity;

      });

    if (this.totalElement) {

      this.totalElement.textContent =
        this.money(total);

    }

  }

    bindAddToCart() {

    if (!this.addButton) return;

    this.addButton.addEventListener(
      'click',
      () => {

        this.addToCart();

      }
    );

  }

  async addToCart() {

    try {

      const cartItems = [];

      if (
        this.includeMainProduct &&
        this.currentMainVariant.id
      ) {

        cartItems.push({

          id: this.currentMainVariant.id,

          quantity: 1

        });

      }

      this.getAccessoryItems()
        .forEach((item) => {

          cartItems.push({

            id: item.id,

            quantity: item.quantity

          });

        });

      if (!cartItems.length) {

        alert(
          'Please select at least one item.'
        );

        return;

      }

      const response =
        await fetch('/cart/add.js', {

          method: 'POST',

          headers: {

            'Content-Type':
              'application/json'

          },

          body: JSON.stringify({

            items: cartItems

          })

        });

      if (!response.ok) {

        throw new Error(
          'Failed to add items to cart.'
        );

      }

      this.openCartDrawer();

    }

    catch (error) {

      console.error(
        'Product Builder:',
        error
      );

    }

  }

  openCartDrawer() {

    document.dispatchEvent(
      new CustomEvent(
        'cart:refresh'
      )
    );

    document.dispatchEvent(
      new CustomEvent(
        'cart:open'
      )
    );

    setTimeout(() => {

      const drawerToggle =
        document.querySelector(
          '[data-cart-drawer-toggle], .m-cart-icon-bubble, a[href="/cart"]'
        );

      if (drawerToggle) {

        drawerToggle.click();

      }

    }, 400);

  }

    init() {

    this.calculate();

  }

}

document.addEventListener(
  'DOMContentLoaded',
  () => {

    document
      .querySelectorAll(
        '[data-builder]'
      )
      .forEach((builder) => {

        new ProductBuilder(
          builder
        );

      });

  }

);

})();